module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('p', {
    staticClass: "ORIM-Dedication",
    staticStyle: {
      "margin-top": "3em"
    }
  }, [_vm._v("To Jenny …")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Dedication"
  }, [_vm._v("and a pinch of powder to the wind for Somnus,")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Dedication"
  }, [_vm._v("the Father of Sleep.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6ebdc9a8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Meyer_LotusCrew_4P_MD-1.vue
// module id = 69
// module chunks = 0